/**
 * Takes in HTML as a string and removes any tags and attributes
 * @param html
 * @returns Content of HTML as string
 */
export function stripStringOfHTML(html: string) {
  const doc = new DOMParser().parseFromString(html, "text/html");

  /* `<style>` tags are removed but it's content remains so this removes any remaining content  */
  const styleTags = doc.getElementsByTagName("style");
  for (let i = styleTags.length - 1; i >= 0; i--) {
    styleTags[i].parentNode?.removeChild(styleTags[i]);
  }

  return doc.body.textContent || "";
}
